import { AuthLayout } from '../../components/AuthLayout';

import { PasswordRecoveryFlow } from './components/PasswordRecoveryFlow/PasswordRecoveryFlow';
import { PasswordRecoveryProvider } from './contexts/PasswordRecoveryContext';

export const PasswordRecovery = () => {
  return (
    <AuthLayout title="Comercial digital">
      <PasswordRecoveryProvider>
        <PasswordRecoveryFlow />
      </PasswordRecoveryProvider>
    </AuthLayout>
  );
};
